import { Component, OnInit, ViewChild } from '@angular/core'
import { ProductDetailService } from '../../../services/product-detail.service'
import { ModalProductHsSyncComponent } from '../../modal-components/modal-product-hs-sync/modal-product-hs-sync.component'
import { CoreService, HsApiService } from '../../../services'
import { ModalProductHsSupplierConfirmComponent } from '../../modal-components/modal-product-hs-supplier-confirm/modal-product-hs-supplier-confirm.component'
import { Currency } from 'depoto-core/src/entities'

@Component({
  selector: 'app-product-automatic-ordering',
  templateUrl: './product-automatic-ordering.component.html',
  styleUrls: ['./product-automatic-ordering.component.scss'],
})
export class ProductAutomaticOrderingComponent implements OnInit {
  @ViewChild('modalProductHsSyncComponent') modalProductHsSyncComponent: ModalProductHsSyncComponent
  @ViewChild('modalProductHsSupplierComponent') modalProductHsSupplierComponent: ModalProductHsSupplierConfirmComponent
  orderAutomatically: boolean
  maxPrice: number = 0
  connectedTemplate: any
  isFetchingConnectedTemplate: boolean = false
  isSellable = false
  customerCode: string
  purchaseCurrencyFromCompany: Currency // there is no way to change this across hs, so it's certain we can use this

  constructor(
    public productDetailService: ProductDetailService,
    public core: CoreService,
    public hsApi: HsApiService,
  ) {}

  ngOnInit() {
    setTimeout(() => {
      // 'cause .. if you just reload right on this tab...***
      try {
        this.customerCode = this.core.services.user.user?.company?.externalId
        if (this.productDetailService.product.externalId?.length) {
          this.fetchDiscounts()
        }
        const customData = JSON.parse(this.productDetailService.product.customData) || {}
        if (customData?.automaticOrders) {
          this.orderAutomatically = customData.automaticOrders.isAutomatic
          this.maxPrice = customData.automaticOrders.maxPrice
        }
        this.purchaseCurrencyFromCompany = this.core.services.user.user?.company?.currency
      } catch (e) {
        console.log(e)
      }
    }, 50)
  }

  connectProductWithHsTemplate(event: { template: any; isOnInit: boolean }) {
    // console.log('auto order:', { template })
    this.connectedTemplate = event.template
    if (!event.isOnInit) {
      this.productDetailService.product.externalId = event.template.hsId
      this.fetchDiscounts()
      this.orderAutomatically = true
      this.updateProductCustomData()
    }
  }

  connectProductWithHsSupplier(allow: boolean) {
    if (allow) {
      const hsSup = this.core.lists.suppliers.find(s => s.externalId === 'henryschein')
      this.productDetailService.product.supplier = hsSup
      if (!this.connectedTemplate) {
        this.modalProductHsSyncComponent.showChildModal()
      }
    } else {
      this.orderAutomatically = false
    }
  }

  orderAutoChanged(event) {
    const needsHsSupplier = this.productDetailService.product?.supplier?.name !== 'Henry Schein'
    // const needsHsSupplier = this.productDetailService.product.supplier.externalId !== 'henryschein' // not in supplier list..
    if (event && needsHsSupplier) {
      this.modalProductHsSupplierComponent.showChildModal()
    }
    if (event && !this.connectedTemplate && !this.isFetchingConnectedTemplate && !needsHsSupplier) {
      this.modalProductHsSyncComponent.showChildModal()
    }
    this.orderAutomatically = event
    this.updateProductCustomData()
  }

  maxPriceChanged(price: number) {
    console.log(price)
    this.maxPrice = price
    this.updateProductCustomData()
  }

  updateProductCustomData() {
    let nextCD: any = {}
    try {
      nextCD =
        (typeof this.productDetailService.product.customData === 'string'
          ? JSON.parse(this.productDetailService.product.customData)
          : this.productDetailService.product.customData) || {}
    } catch (e) {
      console.log(e)
    }
    nextCD.automaticOrders = { maxPrice: this.maxPrice, isAutomatic: this.orderAutomatically }
    this.productDetailService.product.customData = JSON.stringify(nextCD)
  }

  async fetchDiscounts() {
    this.isFetchingConnectedTemplate = true
    const countryCode = 'CZ'
    const discounts = await this.hsApi.getHsDiscounts(this.productDetailService.product.externalId, countryCode)
    // console.log({isSellable: discounts?.bestDiscount?.sellable})
    this.isSellable = discounts?.bestDiscount?.sellable
    this.isFetchingConnectedTemplate = false
  }
}
